import { FormHelperText, InputBase, withStyles } from '@material-ui/core';
import * as React from 'react';
import { Form, FormGroup } from 'react-bootstrap';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  Grid,
  Icon,
  PageTitle,
  SectionHeader,
  SectionHeaderIcon,
  SectionHeaderText,
  SubmitButton
} from '../../../ui';
import { basketActions } from '../../actions';
import { basketSelectors } from '../../redux';
import { menuSelectors } from '../../selectors';
import * as Store from '../../Store';
import { EnsureVisible } from '../../Utilities';
import RouterBackLink from '../RouterBackLink';
import { Toast } from '../Toast/index.weborder';

const Input = withStyles(
  (theme) => ({
    root: {
      width: '100%',
      '&.Mui-focused > input': {
        border: `1px solid ${theme.palette.primary.main}`
      }
    },
    input: {
      paddingLeft: '55px',
      height: '30px',
      width: '100%',
      border: `1px solid ${theme.palette.divider}`
    }
  }),
  { name: 'BootstrapInputBase' }
)(InputBase);

export interface VoucherRoute
  extends RouteComponentProps<
    {
      vrid: number;
      type: 'collection' | 'delivery';
      id: number;
      paymentAccount: number;
      concessionStoreId?: number;
    },
    {}
  > {}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  VoucherRoute;

interface State {
  voucher: string;
  error?: string;
}

class Voucher extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
    this.state = {
      voucher: ''
    };
  }

  private handleVoucherChange = (e: React.ChangeEvent<any>) => {
    const value = (e.target as any).value;
    this.setState({
      voucher: value,
      error: undefined
    });
  };

  private handleSubmit = () => {
    const { menu, orderPayload } = this.props;
    const { voucher } = this.state;
    if (!menu || !voucher) {
      return;
    }
    if (!orderPayload || typeof orderPayload === 'string') {
      return;
    }

    this.setState({
      error: undefined
    });

    this.props
      .checkVoucher({ orderPayload, code: voucher })
      //@ts-ignore
      .then(() => {
        this.props.router.push(this.checkoutLink());
      })
      .catch((error: Error) => {
        this.setState({
          error: error.message
        });
      });
  };

  public componentDidMount() {
    EnsureVisible(findDOMNode(this));

    if (this.props.Basket && this.props.Basket.voucher.status === 'valid') {
      this.setState({ voucher: this.props.Basket.voucher.code });
    }
  }

  private checkoutLink = () => {
    // voucher/474/collection/474/10
    const { params } = this.props;
    return (
      '/checkout/' +
      params.vrid +
      '/' +
      params.type +
      '/' +
      params.id +
      (params.concessionStoreId ? '/' + params.concessionStoreId : '')
    );
  };

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.orderPayload === 'missing_pre_order_time') {
      nextProps.router.replace(this.checkoutLink());
    }
  }

  public render() {
    const {
      AppDesignScheme,
      location: { query },
      Basket,
      orderPayload
    } = this.props;

    const loading = Basket && Basket.voucher.status == 'loading';
    const disabled =
      !Basket || !orderPayload || typeof orderPayload === 'string' || !this.state.voucher;

    const actionText =
      query.action === 'change'
        ? (this.props.translate('Change_voucher') as string)
        : (this.props.translate('Add_voucher_code') as string);

    return (
      <div className="container-fluid flex flex-column fill-height-vh">
        <div className="container flex-one xs-full-width">
          <Toast Messages={this.props.ToastMessages} AppDesignScheme={AppDesignScheme} />
          <div className="row voucher">
            <div className="col-md-12">
              <div style={{ marginTop: '20px' }} />

              <PageTitle>{this.props.translate('Checkout')}</PageTitle>

              <RouterBackLink to={this.checkoutLink()}>
                {this.props.translate('Back')}
              </RouterBackLink>

              <SectionHeader>
                <SectionHeaderIcon>
                  <Icon fontSize="large" aria-hidden color="inherit" className="ei icon_tags" />
                </SectionHeaderIcon>

                <SectionHeaderText title={actionText} />
              </SectionHeader>

              <Form
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <FormGroup className="has-symbol">
                  <Icon
                    aria-hidden
                    color="primary"
                    className="ei icon_tag_alt form-control-symbol"
                  />

                  <Input
                    id="voucherInput"
                    autoFocus
                    placeholder={this.props.translate('Enter_your_voucher_code_here') as string}
                    value={this.state.voucher}
                    onChange={this.handleVoucherChange}
                    key="voucher-input"
                    data-fd="voucher-input"
                  />
                </FormGroup>

                {this.state.error && (
                  <FormHelperText error>
                    {this.props.translate(this.state.error, undefined, {
                      missingTranslationMsg: this.state.error
                    })}
                  </FormHelperText>
                )}

                <Grid container justify="center">
                  <Grid xs={4}>
                    {/* TODO remove after wrapping all component on this page w Grid spacing={3} */}
                    <div style={{ paddingTop: '16px' }} />

                    <SubmitButton
                      loading={loading}
                      disabled={disabled}
                      onClick={this.handleSubmit}
                      dataFd="voucher-add"
                    >
                      {actionText}
                    </SubmitButton>
                  </Grid>
                </Grid>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: Store.State, ownProps: VoucherRoute) => {
  const deliveryType = ownProps.params.type;
  const isDelivery = deliveryType === 'delivery';
  const vrId = ownProps.params.vrid;
  const prId = !isDelivery ? ownProps.params.id : undefined;
  const deliveryLocationId = isDelivery ? ownProps.params.id : undefined;

  const menu = menuSelectors.findMenu(state, {
    vrId,
    deliveryType,
    prId,
    deliveryLocationId
  });

  const orderPayload = basketSelectors.getOrderPayload(state);

  const basket = basketSelectors.getBasketBridge(state);

  return {
    Basket: basket,
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    ToastMessages: state.flipdish.ToastMessages,
    menu,
    orderPayload
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<Store.State, {}, Action>) => {
  return {
    checkVoucher: (payload: basketActions.VoucherProps) => {
      return dispatch(basketActions.checkUserVoucher({ ...payload, throwError: true }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Voucher);
